import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, useCallback } from 'react';

import { GroupsPlaceholder } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';
import { customScrollStyles, InfoBlock, InfoBlockTypes } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { List } from 'APP/components/List/List';
import PopupUserWithMenuItem from 'APP/main/Popups/GetParametersManager/components/PopupUserWithMenuItem';
import { User } from 'STORE/Users/User/User';

import { BlackListMenu } from './BlackListMenu/BlackListMenu';
import {
  useGroupBlackListPopupPresenter,
  IGroupBlackListPopupPresenterParams,
} from './GroupBlackListPopup.presenter';
import styles from './GroupBlackListPopup.styles.m.css';

type IGroupBlackListPopupProps = IGroupBlackListPopupPresenterParams;

export const GroupBlackListPopup: FC<ICommonPopupsProps<IGroupBlackListPopupProps>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useGroupBlackListPopupPresenter(props);

    const renderItem = useCallback((user: User) => {
      return (
        <PopupUserWithMenuItem
          user={user}
          toggleMenu={presenter.toggleMenu}
          isOpenedMenu={presenter.isOpenedMenu}
          onClick={user.startChat}
        />
      );
    }, []);

    return (
      <Popup
        title={t('balck_list_title')}
        isOpened
        onClose={presenter.close}
      >
        <div className={classNames(styles.container, customScrollStyles.container)}>
          <div className={styles.innerContainer}>
            <List
              isLoading={presenter.isLoading}
              hasMore={presenter.hasMore}
              data={presenter.users}
              onEndReached={presenter.onEndReached}
              keyExtractor={presenter.keyExtractor}
              renderItem={renderItem}
              ListEmptyComponent={
                <InfoBlock
                  className={styles.infoBlock}
                  descriptions={[t('ban_empty_ban_list')]}
                  type={InfoBlockTypes.Modal}
                  image={getMascotImageSrc(PROJECT_CONFIG.imageAssets.block)}
                />
              }
              SpinnerComponent={
                <GroupsPlaceholder
                  count={presenter.users.length > 0 ? 2 : 10}
                  className={styles.placeholders}
                />
              }
            />
            <BlackListMenu
              user={presenter.activeUser}
              reference={presenter.menuRef}
              toggleMenu={presenter.toggleMenu}
            />
          </div>
        </div>
      </Popup>
    );
  }
);
